
const MeaStudentPreviousResult = ({ student }) => {
  let sRegOrigin = student?.previous_result;
  return (
    <>
      {sRegOrigin === "NEW" && (
        <div className="text-600 text-sm"><span className="pi pi-user-plus" /><span className="ml-2">NOUVEAU</span></div>
      )}
      {sRegOrigin === "PASSED" && (
        <div className="text-green-500 text-sm"><span className="pi pi-check" /><span className="ml-2">PASSAGE</span></div>
      )}
      {sRegOrigin === "FAILED" && (
        <div className="text-red-500 text-sm"><span className="pi pi-exclamation-triangle" /><span className="ml-2">REDOUBLEMENT</span></div>
      )}
      {sRegOrigin === "ONGOING" && (
        <div className="text-blue-500 text-sm"><span className="pi pi-play" /><span className="ml-2">EN COURS</span></div>
      )}
      {sRegOrigin !== "FAILED" && sRegOrigin !== "PASSED" && sRegOrigin !== "NEW" && sRegOrigin !== "ONGOING" && (
        <div>-</div>
      )}
    </>
  );
};
export default MeaStudentPreviousResult;
